/*
 * @Description:token
 * @Author: 山淑兰
 * @Date: 2020-01-05 23:27:34
 * @LastEditTime : 2020-02-20 20:01:06
 * @LastEditors  : 山淑兰
 */
/*获取token*/
import { Post, Pick } from "@/api/utils";

// const { API_HOST } = G_CONFIG;
const API_HOST = "";

export const PayPath = {
  getToken: API_HOST + "/api/Ver/AccessTemp", //会议支付接口
};

export default {
  /**
   * @title 支付配置
   * @date 2020-01-05
   */
  getToken() {
    return Post({
      url: PayPath.getToken,
    });
  },
};
